<template>
    <el-dialog
        width='978px'
        :title= "translate(`view_loan_modal.loan_recieved`)"
        :visible.sync='show'
        :close-on-click-modal='false'
        :before-close='close'
    >
        <el-tabs
            v-if="!noLoanData"
            v-model="activeCompanyTabName"
            class="view-statement-modal-tabs"
            @tab-click="changeTab"
        >
            <el-tab-pane
                v-for="tab in companyTabs"
                :key="tab.id"
                :label="tab.nome"
                :name="tab.id"
            >
                <div class="view-statement-modal-content">
                    <span class="view-statement-modal-content__label">
                        {{ translate(`view_loan_modal.view_by_product`) }}
                    </span>
                    <el-select
                        v-model='selectedProduct'
                        class="view-statement-modal-content__select"
                        :placeholder="translate(`view_loan_modal.select_product`)"
                        filterable
                        clearable
                        :loading='searchingProducts'
                        :no-data-text="translate(`view_loan_modal.no_products_listed`)"
                    >
                        <el-option
                            v-for="product in products"
                            :key="product.id"
                            :label="translate(`table.product_codes.${product.codigo.toLowerCase()}`)"
                            :value="product.id"
                        >
                            {{ translate(`table.product_codes.${product.codigo.toLowerCase()}`) }}
                        </el-option>
                    </el-select>

                    <section class="view-statement-modal-summary">
                        <h3 class="view-statement-modal-summary__title">
                            {{ translate(`view_loan_modal.loans_recieved_from_industry`) }}
                        </h3>
                        <div class="view-statement-modal-summary__values">
                            <div
                                v-for="item in formattedLoanData"
                                :key="item.title"
                                class="view-statement-modal-summary__item"
                            >
                                <span class="view-statement-modal-summary__label">
                                    {{ item.title }}
                                </span>
                                <strong
                                    class="view-statement-modal-summary__value"
                                    :class="item.value < 0 ? 'negative' : ''"
                                >
                                    {{ formatNumber(item.value) + ' t'}}
                                </strong>
                            </div>
                        </div>
                    </section>

                    <section class="view-statement-modal-transactions">
                        <div
                            v-infinite-scroll="loadMore"
                            class="infinite-list-wrapper"
                            :infinite-scroll-disabled="infiniteScrollDisabled"
                            infinite-scroll-distance="1"
                        >
                                <article
                                    v-for="item in transactions.length"
                                    :key="item"
                                    class="view-statement-modal-transaction__list"
                                >
                                    <div
                                        class="view-statement-modal-transaction__icon"
                                        :class="transactions[item - 1]?.type"
                                    >
                                        <i :class="transactions[item - 1]?.icon"></i>
                                    </div>

                                    <div class="view-statement-modal-transaction__details">
                                        <span class="view-statement-modal-transaction__product">
                                            <i class="el-icon-box"></i>
                                            {{ transactions[item - 1]?.product }}
                                        </span>
                                        <span class="view-statement-modal-transaction__date">
                                            <i class="el-icon-date"></i>
                                            {{
                                                formatDateTime(transactions[item - 1]?.date)[0] + ', ' + formatDateTime(transactions[item - 1]?.date)[1]
                                            }}
                                        </span>
                                        <el-tag
                                            class="view-statement-modal-transaction__tag"
                                            :class="transactions[item - 1]?.loanStatus"
                                            size="mini"
                                            effect="plain"
                                        >
                                            {{ translate(`messages.${transactions[item - 1]?.loanStatus}_volume`)}}
                                        </el-tag>
                                    </div>

                                    <div class="view-statement-modal-transaction__balance">
                                        <strong
                                            class="view-statement-modal-transaction__amount"
                                            :class="transactions[item - 1]?.loanStatus === 'rejected' ? 'rejected' :transactions[item - 1]?.type"
                                        >
                                            {{ transactions[item - 1]?.type === 'received' ? '+' : '-' }}
                                            {{ formatNumber(transactions[item - 1]?.amount) + ' t'}}
                                        </strong>
                                    </div>
                                </article>
                                <article
                                    v-if="loading || noMore"
                                    class="view-statement-modal-transaction"
                                >
                                    <p v-if="loading" class="infinite-list-wrapper__feedback">
                                        {{ translate(`view_loan_modal.loading`) }}
                                    </p>
                                    <p v-else-if="noMore" class="infinite-list-wrapper__feedback">
                                        {{ translate(`view_loan_modal.no_more_items`) }}
                                    </p>
                                </article>
                            </div>
                    </section>
                </div>
            </el-tab-pane>
        </el-tabs>
        <div v-else class="view-statement-modal-no-data">
            <p>
                {{ translate(`view_loan_modal.no_loan_data`) }}
            </p>
        </div>
        <div class="actions" style="margin-top: 20px; text-align: right;">
            <el-button @click="close">{{ translate(`messages.back`) }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import formatters from '@/utils/formatters';
import { mapActions, mapState } from 'vuex';

export default {
    name: 'warehouseTransactionCancelModal',
    props: {
        show: {
            type: Boolean,
            required: true
        },
        selectedFacilityLoan: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            loading: false,
            noMore: false,
            companyTabs: [],
            activeCompanyTabName: null,
            formattedLoanData: {},
            selectedProduct: null,
            searchingProducts: false,
            transactions: [],
            size: 10,
            page: null,
            noLoanData: false
        };
    },
    computed: {
        ...mapState('warehouseModule', ['loanCompanyList', 'loanTotalizersModal', 'loansList']),
        ...mapState('relatorioRastreabilidadeModule', ['products']),
        infiniteScrollDisabled() {
            return this.loading || this.noMore;
        }
    },
    mounted() {
        this.fetchLoanCompaniesByFacility(this.selectedFacilityLoan).then(() => {
            if (this.loanCompanyList.length > 0) {
                this.companyTabs = this.loanCompanyList;
                this.activeCompanyTabName = this.companyTabs.length > 0 ? this.companyTabs[0].id : null;
                this.getProducts();
            } else {
                this.noLoanData = true;
            }
        });
    },
    watch: {
        selectedProduct: {
            handler(newVal) {
                this.fetchData();
            }
        },
        loanTotalizersModal: {
            handler(newVal) {
                this.processarDadosTotalizadores();
            },
            deep: true
        },
        '$i18n.locale': {
            handler() {
                this.processarDadosTotalizadores();
            }
        }
    },
    methods: {
        ...mapActions('warehouseModule', ['fetchLoanTotalizerModal', 'fetchLoanCompaniesByFacility', 'fetchLoans']),
        ...mapActions('relatorioRastreabilidadeModule', ['fetchProducts']),
        translate(key, params = {}) {
            const base = 'warehouse';
            return this.$t(`${base}.${key}`, params);
        },
        close() {
            this.page = null;
            this.$emit('close');
        },
        changeTab() {
            this.fetchData();
        },
        getProducts() {
            this.fetchProducts().then(() => {
                this.selectedProduct = this.products.find(product => product.codigo === 'SOJA').id;
            });
        },

        processarDadosTotalizadores() {
            if (!this.loanTotalizersModal) {
                this.formattedLoanData = {};
                return;
            }

            const formattedLoanData = {};

            Object.keys(this.loanTotalizersModal).forEach(key => {
                formattedLoanData[key] = {
                    value: this.loanTotalizersModal[key].volumeTotalTon
                };

                if (key === 'volumeRecebido') {
                    formattedLoanData[key].title = this.translate(`messages.received_volume`);
                } else if (key === 'volumeEnviado') {
                    formattedLoanData[key].title = this.translate(`messages.sent_volume`);
                } else if (key === 'saldo') {
                    formattedLoanData[key].title = this.translate(`messages.balance`);
                }
            });

            this.formattedLoanData = formattedLoanData;
        },

        formatNumber(value) {
            if (value === null || value === undefined) return '-';
            return formatters.minFormatNumber(value, 2, this.$i18n.locale);
        },

        fetchData() {
            this.transactions = [];
            this.page = 1;

            const params = this.getFetchParams();
            this.fetchLoanTotalizerModal(params);
            this.loading = true;
            this.fetchLoans(params).then(() => {
                this.noMore = this.loansList.itens.length < this.size;
                this.addToTransactionList(this.loansList.itens);
            });
        },

        getFetchParams() {
            return {
                idArmazem: this.selectedFacilityLoan,
                idProduto: this.selectedProduct,
                idEmpresaEmprestimo: this.activeCompanyTabName.toString(),
                page: this.page,
                size: this.size,
                ordenacao: 'dataCadastro,desc'
            };
        },

        addToTransactionList(loans) {
            const transactions = loans;
            transactions.forEach(t => {
                let tipo = t.tipo === 'ENTRADA' ? 'received' : 'sent';
                let loanStatus = tipo;
                if (t.statusTransacao === 'EM_TRANSITO') {
                    loanStatus = 'in_transit';
                } else if (t.statusTransacao === 'REPROVADA') {
                    loanStatus = 'rejected';
                }

                this.transactions.push({
                    id: t.id,
                    type: tipo,
                    icon: t.tipo === 'ENTRADA' ? 'el-icon-bottom' : 'el-icon-top',
                    product: this.translate(`messages.${t.codigoProduto.toLowerCase()}`),
                    date: t.dataCadastro,
                    amount: t.volumeDestinoTon,
                    loanStatus: loanStatus,
                    statusTransacao: t.statusTransacao
                });
            });
            this.loading = false;
        },

        loadMore() {
            if (this.infiniteScrollDisabled || !this.page) return;

            this.loading = true;
            this.page++;
            const params = this.getFetchParams();
            this.fetchLoans(params).then(() => {
                this.noMore = this.loansList.itens.length < this.size;
                this.addToTransactionList(this.loansList.itens);

                setTimeout(() => {
                    this.loading = false;
                }, 500);
            });
        },

        formatDateTime(dateTimeFromApi) {
            return formatters.splitApiDateTimeForTable(dateTimeFromApi, this.$i18n.locale);
        }
    }
};
</script>

<style scoped lang="scss">
.view-statement-modal-no-data {
    height: 300px;
    text-align: center;
    padding: 20vh 0;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    margin-bottom: 16px;

    p {
        color: #b2b5b9;
    }
}

.view-statement-modal-tabs {
    margin-top: 8px;

    ::v-deep .el-tabs__nav-wrap::after {
        display: none;
    }
}

.view-statement-modal-content {
    color: #5f6368;
    padding-top: 4px;

    &__label {
        display: block;
        font-size: 13px;
        font-weight: 600;
        margin-bottom: 8px;
    }

    &__select {
        margin-bottom: 16px;
        width: 350px;
    }
}

.view-statement-modal-summary,
.view-statement-modal-transactions {
    border: 1px solid #e4e7ed;
    border-radius: 4px;
}

.view-statement-modal-summary {
    margin-bottom: 16px;
    padding: 16px;

    &__title {
        color: #5f6368;
        font-size: 16px;
        font-weight: 600;
        margin: 0 0 18px;
    }

    &__values {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 24px;
    }

    &__label {
        display: block;
        font-size: 13px;
        font-weight: 600;
        margin-bottom: 6px;
    }

    &__value {
        color: #3f3f46;
        font-size: 16px;

        &.negative {
            color: #e04f5f !important;
        }
    }
}

.view-statement-modal-transactions {
    padding: 12px 16px;
}

.view-statement-modal-transaction {
    align-items: center;
    border-bottom: 1px solid #e4e7ed;
    padding: 16px 0;

    &__list {
        display: grid;
        grid-template-columns: 52px 1fr auto;
        gap: 16px;
        align-items: center;
        border-bottom: 1px solid #e4e7ed;
        padding: 16px 0;
    }

    &:last-child {
        border-bottom: none;
    }

    &__icon {
        align-items: center;
        border-radius: 50%;
        display: flex;
        height: 24px;
        justify-content: center;
        width: 24px;

        &.sent {
            background-color: #edf7ee;
            color: #1f7a39;
        }

        &.received {
            background-color: #eef3ff;
            color: #2450a4;
        }

        &.in_transit {
            background-color: #FDF7E8;
            color: #6D4D09;
        }

        &.rejected {
            background-color: #FCEBEA;
            color: #991F1A;
        }
    }

    &__details {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    &__product,
    &__date {
        align-items: center;
        display: flex;
        font-size: 14px;
        gap: 8px;
    }

    &__product {
        font-weight: 600;
    }

    &__tag {
        border: none;
        font-weight: 600;
        width: fit-content;
        padding: 0 10px !important;

        &.sent {
            background-color: #dff2e5;
            color: #1f7a39;
        }

        &.received {
            background-color: #e4edff;
            color: #2450a4;
        }
        
        &.in_transit {
            background-color: #FDF7E8;
            color: #6D4D09;
        }
        
        &.rejected {
            background-color: #FCEBEA;
            color: #991F1A;
        }
    }

    &__balance {
        display: flex;
        flex-direction: column;
        gap: 6px;
        text-align: right;
        margin-right: 16px;
    }

    &__amount {
        color: #3f3f46;
        font-size: 16px;

        &.sent {
            color: #3f3f46;
        }

        &.rejected {
            color: #aaaaaf;
            text-decoration: line-through;
        }
    }

    &__after-balance {
        font-size: 12px;
    }
}

.infinite-list-wrapper {
    max-height: 220px;
    overflow-y: auto;

    &__feedback {
        width: 100%;
        color: #b2b5b9;
        margin: 4px 0 0 0;
        padding: 8px 0 0 0;
        text-align: center;
    }
}
</style>
